import { Loading, Toast } from 'antd-mobile'
import React, { useState } from 'react'

import uploadImage from '@/utils/bridge/h5origin/uploadImage'

import logger from '@/utils/logger'

import { batchDownloadSigns } from './service'
import './index.less'

const UploadFile: React.FC = (props: any) => {
  const { disabled = false, element, hasToken = true, value, onConfirm, showLoading } = props
  const [loading, setLoading] = useState(false)

  const openFile = () => {
    if (disabled) return
    const inputEl = document.createElement('input')
    inputEl.type = 'file'
    inputEl.accept = 'image/*'
    inputEl.multiple = true // 限制只能选择一张图片/多张图片
    inputEl.style.display = 'none'
    inputEl.addEventListener('change', async (event: any) => {
      const files: any = Array.from(event.target.files)
      if (files?.length > 0) {
        await uploadMultipleFiles(files)
      }
      document.body.removeChild(inputEl)
    })
    document.body.appendChild(inputEl)
    inputEl.click()
  }

  const uploadMultipleFiles = async (files: File[]) => {
    showLoading
      ? showLoading(true)
      : Toast.show({
          icon: 'loading',
          content: '图片上传中...'
        })
    setLoading(true)

    try {
      // 批量上传所有文件
      const uploadPromises = files.map((file) => uploadImage(file, hasToken))
      const objectKeys = await Promise.all(uploadPromises)

      // 获取所有文件的签名URL
      const { data: fileData } = await batchDownloadSigns({
        params: objectKeys.map((key) => ({ object_key: key })),
        hasToken
      })

      const _value = value || []
      fileData?.forEach((item: any) => {
        if (_value?.findIndex((item0: any) => item0?.object_key === item?.object_key) === -1) {
          _value.push(item)
        }
      })

      onConfirm?.(_value)
      showLoading ? showLoading(false) : Toast.clear()
      setLoading(false)
    } catch (e) {
      console.error(e)
      logger(e)
      showLoading ? showLoading(false) : Toast.clear()
      setLoading(false)
    }
  }

  return loading ? (
    <div className='upload-file-loading'>
      图片上传中
      <Loading />
    </div>
  ) : (
    <span onClick={openFile}>{element}</span>
  )
}

export default UploadFile
